import React, { Component } from "react";
import { connect } from "react-redux";
import * as authHelpers from "./authHelpers";
import { actionCreators as authActions } from "../redux/actions/authActions";
import { bindActionCreators } from "redux";
import * as routeHelpers from './routeHelpers'

export default function (ComposedComponent) {
    class AuthGuard extends Component {
        constructor(props) {
            super(props);
            const user = authHelpers.getAuthUser();

            var loginPath = this.props.location.pathname.endsWith('/login') || this.props.location.pathname.endsWith('/verification');
            var acceptanceOfTermsPath = this.props.location.pathname.includes('/acceptance-of-terms');

            var redirectRoute = null;

            if (!user && !loginPath) {
                redirectRoute = '/login';
            }
            else if (user && !user.consent && !acceptanceOfTermsPath) {
                redirectRoute = '/acceptance-of-terms';
            }

            if (redirectRoute) {
                this.props.history.push(authHelpers.buildRouteWithAuthParams(redirectRoute, new URLSearchParams(this.props.location.search)));
            }
        }

        render() {
            return <ComposedComponent {...this.props} />;
        }
    }

    return connect(
        (state) => state.authentication,
        (dispatch) => bindActionCreators(authActions, dispatch)
    )(AuthGuard);
}
